import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("top");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const sections = navLinks
      .map((link) => document.getElementById(link.id))
      .filter((el): el is HTMLElement => Boolean(el));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 },
    );
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 border-b border-background-200/70 backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav className="flex h-16 items-center justify-between px-4 md:px-8">
        <a
          href="#top"
          className="flex items-center gap-2 whitespace-nowrap"
          onClick={() => setMenuOpen(false)}
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-lg ${
              scrolled ? "bg-primary-500 text-foreground-950" : "bg-background-50/15 text-background-50"
            }`}
          >
            <i className="ri-movie-2-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            星辰影视
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => {
            const isActive = active === link.id;
            return (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  className={`block whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                    scrolled
                      ? isActive
                        ? "bg-primary-100 text-primary-800"
                        : "text-foreground-700 hover:text-primary-700"
                      : isActive
                        ? "bg-background-50/20 text-background-50"
                        : "text-background-100 hover:text-background-50"
                  }`}
                >
                  {link.label}
                </a>
              </li>
            );
          })}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#movies"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors md:inline-flex ${
              scrolled
                ? "bg-primary-500 text-foreground-950 hover:bg-primary-600"
                : "bg-background-50 text-foreground-950 hover:bg-background-100"
            }`}
          >
            快速找片
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden">
          <ul className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="block rounded-md bg-background-100 px-3 py-2 text-sm font-medium text-foreground-800"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}